import script from "./DefaultTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultTemplate.vue?vue&type=script&setup=true&lang=js"

import "./DefaultTemplate.vue?vue&type=style&index=0&id=1b99ce18&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b99ce18"]])

export default __exports__